import React from "react";
import "./rich-text.scss";
import { parseHtml } from "helpers";
const RichText = ({ richText }) => (
  <div className="RichText">{parseHtml(richText)}</div>
);

export default RichText;
